window.duo.table = {}
window.duo.table.storage = {}

window.duo.table.init = (identifier, options) => {
	window.duo.table.storage[identifier] = new DuoFormTable(identifier, options);
}

window.duo.table.get = (identifier) => window.duo.table.storage[identifier];
window.duo.table.manualRebuild = () => {
	for (let identifier in window.duo.table.storage) {
		const table = window.duo.table.get(identifier);
		if (table.manualRebuild) {
			table.rebuildStorage();
		}
	}
}

class DuoFormTable {

	/**
	 * Constructs a DuoFormTable
	 * @method constructor
	 * @param  {string}    identifier The identifier for the table
	 * @param  {object}    options    An object with options
	 */
	constructor (identifier, options) {

		//
		// Set instance variables
		this.isInitialized			= false;
		this.identifier 			= identifier;
		this.arrayIdentifier		= options.arrayIdentifier || identifier.replace('-', '_') + '_entries';
		this.validator				= options.validator || null;
		this.fields					= options.fields || null;
		this.uniqueField			= options.uniqueField || null;
		this.manualRebuild			= options.manualRebuild || false;
		this.columns				= options.columns || [];
		this.showModalAddHandler	= options.showModalAdd;
		this.showModalUpdateHandler	= options.showModalUpdate;
		this.onRebuildHandler		= options.onRebuild || (() => {});
		this.modalSubmitAdd			= options.modalSubmitAdd || 'Hinzufügen';
		this.modalSubmitUpdate		= options.modalSubmitUpdate || 'Aktualisieren';
		this.deletable				= options.deletable == false || options.deletable == true ? options.deletable : true;
		this.showsStatus			= options.showsStatus == false || options.showsStatus == true ? options.showsStatus : true;
		this.requestMeta			= options.requestMeta || {};
		this.validateForms			= options.validateForms	|| [];

		//
		// Retrieve reusable nodes
		this.deleteModal = document.querySelector('#modal-delete-entry');
		if (this.deleteModal) {
			this.deleteModalSubmit = this.deleteModal.querySelector('button[type="submit"]');
		} else {
			this.deletable = false;
		}
		this.modal					= document.querySelector(options.modal || null);
		this.modalSubmit			= this.modal.querySelector(options.modalSubmit || 'button[type="submit"]');
		this.group					= document.querySelector(`[form-table="${ this.identifier }"]`);
		this.table					= this.group.querySelector(`table#${ this.identifier }-table`);

		//
		// Create an internal object to store the table data
		this.storage	= {
			container:	this.group.querySelector(`div#${ this.identifier }-storage`),
			entries:	[]
		}

		this.initializeStorage();

		//
		// Register events
		this.registerEvents();

		//
		// Rebuild the storage and the table using the collected data
		if (!this.manualRebuild) {
			this.rebuildStorage();
		}

		this.isInitialized = true;
	}

	/**
	 * Initializes the storage on page load
	 * @method initializeStorage
	 */
	initializeStorage () {
		$(this.storage.container).find('div').each((index, container) => {
			let entry = {
				uuid:	$(container).attr('uuid'),
				fields:	{}
			};

			//
			// Map the params to the data entry`s values
			for (let index in this.fields) {
				const field = this.fields[index];
				entry.fields[field] = $(container).find(`input[name="${ this.arrayIdentifier}[${ entry.uuid }][${ field }]"]`).val() || null;
			}

			this.storage.entries.push(entry);
		})
	}

	/**
	 * Registers events
	 * @method registerEvents
	 */
	registerEvents () {

		//
		// Handles the click of the add or update button
		this.modalSubmit.addEventListener('click', event => {

			//
			// Abort if the modal was used for another table
			if ($(this.modal).attr('model-opened-for') !== this.identifier) {
				return;
			}

			let inputs = [];
			this.fields.forEach(field => {
				const element = this.modal.querySelector(`[name="${ field }"]`);
				inputs.push(element === null ? null : duo.fieldValue(element));
			});

			const updatingEntryUuid = $(event.target).attr('updating-entry-uuid');
			if (updatingEntryUuid !== undefined) {
				this.update(updatingEntryUuid, ...inputs);
			} else {
				this.add(...inputs);
			}

			$(this.modalSubmit).removeAttr('updating-entry-uuid');
			$(this.modal).modal('hide');
		});

		//
		// Handles the click of an existing entry to update it
		$(this.table).on('click', 'tr[data-entry-id]', event => {
			event.preventDefault();

			const entryId = $(event.target).closest('tr').attr('data-entry-id');

			if (this.deleteModal && $(event.target).attr('data-target') == `#${ this.deleteModal.id }`) {
				$(this.deleteModalSubmit)
					.attr('entry-type', this.identifier)
					.attr('entry-uuid', entryId);
				return;
			}

			const entries = this.storage.entries.filter(entry => entry.uuid == entryId);

			if (entries.length !== 1) {
				this.showModalAdd();
			} else {
				this.showModalUpdate(entries[0]);
			}
		});

		//
		// Handles the click of the add button outside the table
		$(this.group).find('[data-entry-create]').on('click', event => {
			event.preventDefault();
			this.showModalAdd();
		});

		//
		// Handles the click of the delete entry button in the delete entry modal
		if (this.deleteModal) {
			$(this.deleteModalSubmit).on('click', event => {
				const entryType = $(event.target).attr('entry-type');
				const entryUuid = $(event.target).attr('entry-uuid');

				if (entryType !== undefined && entryType == this.identifier && entryUuid !== undefined) {
					this.remove(entryUuid);
					$(this.deleteModalSubmit).removeAttr('entry-type').removeAttr('entry-uuid');
				}

				$(this.deleteModal).modal('hide');
			});
		}
	}

	/**
	 * Adds a new entry to the list
	 * @method add
	 * @param  {array} fields A parameter list with field values
	 */
	add (...fields) {

		//
		// Create an object that will represent the new data entry
		// Each entry has a unique identifier and a set of values
		let entry = {
			uuid:	duo.uuid(),
			fields:	{}
		};

		//
		// Map the params to the data entry`s values
		for (let index in this.fields) {
			entry.fields[this.fields[index]] = fields[index] || null;
		}

		//
		// Push the new data entry
		this.storage.entries.push(entry);

		this.rebuildStorage();
	}

	/**
	 * Updates an existing entry with the given field values
	 * @method update
	 * @param  {string} uuid   The id or uuid of the existing entry
	 * @param  {array}  fields A list of params
	 */
	update (uuid, ...fields) {

		//
		// Get the index of the entry to update
		const entryIndex = this.storage.entries.findIndex(entry => entry.uuid == uuid);

		//
		// Map the params to the data entry`s values
		for (let index in this.fields) {
			this.storage.entries[entryIndex].fields[this.fields[index]] = fields[index] || null;
		}

		this.rebuildStorage();
	}

	/**
	 * Removes an existing entry
	 * @method remove
	 * @param  {[type]} uuid [description]
	 * @return {[type]}      [description]
	 */
	remove (uuid) {
		this.storage.entries = this.storage.entries.filter(entry => entry.uuid !== uuid);

		this.rebuildStorage();
	}

	/**
	 * Rebuilds the storage and table container
	 * @method rebuildStorage
	 */
	rebuildStorage () {
		this.storage.container.innerHTML = '';

		$(this.table).find('tbody > tr:not(.empty-content)').remove();
		const body = $(this.table).find('tbody');

		this.storage.entries.forEach(entry => {
			$(this.storage.container).append(`<div uuid="${ entry.uuid }">`);
			const entryContainer = this.storage.container.querySelector(`div[uuid="${ entry.uuid }"]`);

			for (let field in entry.fields) {
				$(entryContainer).append(`<input name="${ this.arrayIdentifier}[${ entry.uuid }][${ field }]" type="hidden" value="${ entry.fields[field] || '' }">`);
			}

			const columns = this.columns.map(f => `<td>${ f(this.modal, entry) }</td>`);

			const statusColumn = !this.showsStatus ? `` : `
				<td searchable="false" class="nohref" data-status-column>
					<div class="d-flex justify-content-center" data-status-icon></div>
				</td>
			`;

			const removeColumn = !this.deletable ? `` : `
				<td searchable="false" class="nohref">
					<div class="table__options">
						<i class="fas fa-trash-alt" data-toggle="modal" data-target="#modal-delete-entry" aria-hidden="true"></i>
					</div>
				</td>
			`;

			body.append(`<tr data-href data-entry-id="${ entry.uuid }">${ columns }${ statusColumn }${ removeColumn }</tr>`);

			if (this.validator !== null && this.showsStatus) {
				duo.validation.requestNow(this.validator, entry.fields, result => {
					const statusColumn = this.table.querySelector(`tr[data-entry-id="${ entry.uuid }"] [data-status-column]`);

					statusColumn.setAttribute('sortable-value', -result.general.status)
					statusColumn.querySelector('[data-status-icon]').innerHTML = result.general.render;
					$('[data-toggle="tooltip"]').tooltip();
				}, this.requestMeta);
			}
		});

		if (this.isInitialized) {

			if (document.querySelector('[validation-on-load]') !== null)
			{
				//
				// Trigger the passed validate form requests
				this.validateForms.forEach(validatable => {
					window.duo.validation.request(validatable);
				});
			}

			this.onRebuildHandler();
		}
	}

	validate () {
		this.storage.entries.forEach(entry => {
			duo.validation.requestNow(this.validator, entry.fields, result => {
				const statusColumn = this.table.querySelector(`tr[data-entry-id="${ entry.uuid }"] [data-status-column]`);

				statusColumn.setAttribute('sortable-value', -result.general.status)
				statusColumn.querySelector('[data-status-icon]').innerHTML = result.general.render;
				$('[data-toggle="tooltip"]').tooltip();
			}, this.requestMeta);
		});
	}

	showModalGeneral () {
		$(this.modal).attr('model-opened-for', this.identifier);
		if (this.uniqueField) {
			const field				= this.modal.querySelector(`[name="${ this.uniqueField }"]`);
			const uniqueFieldValue	= this.getValuesForField(this.uniqueField);

			if (field.tagName == 'SELECT') {
				field.querySelectorAll(`option`).forEach(option => {
					if (uniqueFieldValue.includes(option.value)) {
						option.classList.add('d-none');
					} else {
						option.classList.remove('d-none');
					}
				});
			}
		}
	}

	/**
	 * Shows the modal to add a new entry
	 * @method showModalAdd
	 */
	showModalAdd () {
		duo.validation.hardPreventValidation(this.validator, true);

		this.showModalGeneral();
		this.showModalAddHandler(this, this.modal);

		$(this.modalSubmit).text(this.modalSubmitAdd);
		$(this.modalSubmit).removeAttr('updating-entry-uuid');
		$(this.modal).modal('show');

		duo.validation.hardPreventValidation(this.validator, false);
		duo.validation.request(this.validator);
	}

	/**
	 * Shows the modal to update an existing entry
	 * @method showModalUpdate
	 * @param  {Object}        entry The entry to update
	 */
	showModalUpdate (entry) {
		duo.validation.hardPreventValidation(this.validator, true);

		this.showModalGeneral();
		this.showModalUpdateHandler(this, this.modal, entry);

		$(this.modalSubmit).text(this.modalSubmitUpdate);
		$(this.modalSubmit).attr('updating-entry-uuid', entry.uuid);
		$(this.modal).modal('show');

		duo.validation.hardPreventValidation(this.validator, false);
		duo.validation.request(this.validator);
	}

	/**
	 * Fills the modal fields with the given data
	 * @param {object} data
	 */
	fillFields (data) {
		duo.validation.hardPreventValidation(this.validator, true);

		this.showModalUpdateHandler(this, this.modal, { fields: data });

		duo.validation.hardPreventValidation(this.validator, false);
		duo.validation.request(this.validator);
	}

	getValuesForField (field) {
		return this.storage.entries.map(entry => entry.fields[field]);
	}
}
